// New Types are to be added to the end of the list. Do not change the order.
export var Type;
(function (Type) {
    Type[Type["None"] = 0] = "None";
    Type[Type["Booleans"] = 1] = "Booleans";
    Type[Type["Float32s"] = 2] = "Float32s";
    Type[Type["Float64s"] = 3] = "Float64s";
    Type[Type["Int8s"] = 4] = "Int8s";
    Type[Type["Int16s"] = 5] = "Int16s";
    Type[Type["Int32s"] = 6] = "Int32s";
    Type[Type["Strings"] = 7] = "Strings";
    Type[Type["UnsignedInt8s"] = 8] = "UnsignedInt8s";
    Type[Type["UnsignedInt16s"] = 9] = "UnsignedInt16s";
    Type[Type["UnsignedInt32s"] = 10] = "UnsignedInt32s";
})(Type || (Type = {}));
//# sourceMappingURL=iinferenceService.js.map